// import { useState } from "react";
// import Barcode from "react-barcode";
import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import Barcode from "react-barcode";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { ApiLink } from "../APILink/ApiLink";
import axios from "axios";
import authHeader from "../Auth/authHeader";
import { errorAlert } from "../Components/Alerts";
import { Printer } from "lucide-react";
import Autocomplete from "@mui/material/Autocomplete";

const headers = authHeader();

const getCountryFromBarcode = (barcode) => {
  if (!barcode || barcode.length < 3) return { name: "Kosova", code: "xk" };
  const prefix = barcode.substring(0, 3);
  return prefix;
};

const LABEL_FORMATS = [
  { label: "101 × 101 mm (labelë barkodi - standard)",  width: "101.6mm",  height: "101.6mm",   scale: 1 },
  { label: "57 × 32 mm (standard i vogël)", width: "72mm",   height: "32mm",   scale: 1.0 },
  { label: "58 × 40 mm (i zakonshëm)",     width: "58mm",   height: "40mm",   scale: 1.3 },
  { label: "40 × 30 mm (mini labelë)",     width: "40mm",   height: "30mm",   scale: 0.8 },
  { label: "62 × 29 mm (Brother DK)",      width: "62mm",   height: "29mm",   scale: 1.0 },
  { label: "62 × 100 mm (labelë e gjatë)", width: "62mm",   height: "100mm",  scale: 2.2 },
  { label: "2.25″ × 1.25″ (Zebra USA)",   width: "2.25in", height: "1.25in", scale: 1.0 },
  { label: "4″ × 2″ (Zebra/Dymo i madh)", width: "4in",    height: "2in",    scale: 2.2 },
];

const BarcodeGeneratorModal = ({ open, handleClose, articleData }) => {
  const [barcode, setBarcode] = useState("");
  const [flagCode, setFlagCode] = useState("");
  const [countryName, setCountryName] = useState("");
  const printRef = useRef(null);
  const [selectedFormat, setSelectedFormat] = useState(LABEL_FORMATS[0]);

  const [articleOptions, setArticleOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const getArticleId = (article) => article?.rowInfo?.ArticleID ?? article?.ArticleID ?? article?.articleId ?? null;
  const getArticleName = (article) => article?.ArticleName ?? article?.rowInfo?.ArticleName ?? article?.articleName ?? "";
  const getArticleBarcode = (article) => article?.Barcode ?? article?.barcode ?? article?.rowInfo?.Barcode ?? article?.rowInfo?.barcode ?? "";
  const getArticleSalesPrice = (article) => article?.SalesPrice ?? article?.salesPrice ?? article?.rowInfo?.SalesPrice ?? article?.rowInfo?.salesPrice ?? null;

  const getFlagCode = (article) => {
    const prefix = getCountryFromBarcode(getArticleBarcode(article));

    if (prefix.length === 3 && /^\d+$/.test(prefix)) {
      fetchFlagCode(prefix);
    } else {
      setFlagCode("xk");
      setCountryName("Kosova");
    }
  };

  const fetchFlagCode = async (prefix) => {
    try {
      const response = await axios.get(ApiLink.API_URL + "Companies/FlagCode", {
        headers,
        params: { prefix: prefix },
      });
      setFlagCode(response.data[0].FlagCode);
      setCountryName(response.data[0].StateName);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Kthehet nga serveri për mungesë qasje
      } else {
        errorAlert("Gabim në kërkesë:", error);

        if (
          error.response &&
          error.response.data &&
          error.response.data.errorMessage
        ) {
          errorAlert(
            `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
          );
        } else if (error.message) {
          errorAlert(`Gabim: ${error.message}`);
        } else {
          errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
        }
      }
    }
  };

  const fetchArticleSalesOptions = async (articleId) => {
    try {
      // Thirrja e endpoint-it të ri në controller
      const response = await axios.get(
        `${ApiLink.API_URL}Article/sales-options/${articleId}`,
        { headers },
      );

      // Ruajtja e të dhënave në state (supozojmë se ke një state për listën)
      setArticleOptions(response.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Mesazhi kur nuk gjendet asnjë opsion për atë ID
        errorAlert("Nuk u gjet asnjë opsion shitjeje për këtë artikull.");
      } else {
        // Logjika jote ekzistuese për gabimet
        if (
          error.response &&
          error.response.data &&
          error.response.data.errorMessage
        ) {
          errorAlert(`Gabim: ${error.response.data.errorMessage}`);
        } else {
          errorAlert("Gabim gjatë marrjes së opsioneve të artikullit.");
        }
      }
    }
  };

  // const handleGenerate = () => {
  //     const detectedCountry = getCountryFromBarcode(barcode);
  //     setCountry(detectedCountry);
  // };

  const closeModal = () => {
    handleClose();
    setFlagCode("");
    setCountryName("");
  };

  const barcodeValue = selectedOption?.NewBarcode || selectedOption?.Barcode || barcode || getArticleBarcode(articleData) || "";

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "Barkod",
    ignoreGlobalStyles: true,
    onPrintError: (_, error) => {
      errorAlert(`Gabim gjatë printimit: ${error?.message || "i panjohur"}`);
    },
    pageStyle: `
      @page {
        size: ${selectedFormat.width} ${selectedFormat.height} portrait;
        margin: 0;
      }
      * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        color-adjust: exact;
        box-sizing: border-box;
      }
      html, body {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
        background: #fff;
      }
      .print-label {
        width: ${selectedFormat.width} !important;
        height: ${selectedFormat.height} !important;
        margin: 0 auto !important;
        padding: 2mm !important;
        overflow: hidden !important;
        position: static !important;
        border: none !important;
        background: #fff !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
      }
      .print-label h3 {
        font-size: 8pt !important;
        margin: 0 0 1mm 0 !important;
        padding: 0 !important;
      }
      .print-label svg {
        image-rendering: pixelated;
        max-height: 15mm !important;
        max-width: 100% !important;
        height: auto !important;
        width: auto !important;
      }
    `,
  });

  const handlePrintClick = () => {
    if (!barcodeValue) {
      errorAlert("Barkodi mungon. Ju lutem zgjidhni një opsion shitjeje.");
      return;
    }
    if (!printRef.current) {
      errorAlert("Përmbajtja për print nuk u ngarkua ende. Provo përsëri.");
      return;
    }
    handlePrint();
  };

  // const handlePrint = useReactToPrint({
  //     content: () => printRef.current, // Referenca e div-it që do të printohet
  //     documentTitle: "Barcode Print", // Opsionale: Vendos një titull të dokumentit
  //     onAfterPrint: () => console.log("Printing completed!"), // Opsionale: Callback pas printimit
  // });
  // const print = useReactToPrint({
  //     content: () => printRef.current,
  // });

  // const handlePrint = () => {
  //     for (let i = 0; i < copies; i++) {
  //         setTimeout(() => {
  //             print();
  //             console.log(`Printimi ${i}`);
  //         }, i * 500);
  //     }
  // };

  //    const handleAutocompleteArticleOptions = (event, value) => {
  //     if (value) {
  //         // setFormData((prevState) => ({
  //         //     ...prevState,
  //         //     LedgerID: value.LedgerID,
  //         // }));
  //     } else {
  //         // setFormData((prevState) => ({
  //         //     ...prevState,
  //         //     LedgerID: "",
  //         // }));
  //     }
  // };

  // const defaultPropsArticleOptions = {
  //     options: article,
  //     getOptionLabel: (option) =>
  //         `${option.LedgerNameEN}` || "",
  //     renderOption: (props, option) => (
  //         <>
  //             <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //                 <span>
  //                     <b> {option.LedgerNameEN}</b><br />
  //                 </span>
  //             </li>
  //         </>
  //     ),
  // };
  //   const handleAutocompleteArticleOptions = (event, value) => {
  //     if (value) {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         Barcode: value.NewBarcode,
  //         ArticleSalesOptionsID: value.ArticleSalesOptionsID,
  //         SalesPrice: value.NewSalesPrice,
  //       }));
  //     } else {
  //       // Opsionale: Çfarë ndodh nëse e bën "Clear" (X)
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         Barcode: "",
  //         ArticleSalesOptionsID: null,
  //         SalesPrice: 0,
  //       }));
  //     }
  //   };
  const fallbackOption = (() => {
    const barcode = getArticleBarcode(articleData);
    const price = getArticleSalesPrice(articleData);
    if (!barcode && price == null) {
      return null;
    }

    return {
      ArticleSalesOptionsID: 0,
      NewBarcode: barcode,
      Barcode: barcode,
      NewSalesPrice: price ?? 0,
    };
  })();

  const resolvedArticleOptions = articleOptions?.length > 0
    ? articleOptions
    : fallbackOption
      ? [fallbackOption]
      : [];

  const defaultPropsArticleOptions = {
    options: resolvedArticleOptions,
    getOptionLabel: (option) =>
      option ? `${option.NewBarcode || option.Barcode || ""} - ${getArticleName(articleData)}` : "",
    renderOption: (props, option) => (
      <li
        {...props}
        key={option.ArticleSalesOptionsID ?? `${option.NewBarcode || option.Barcode || "fallback"}`}
        style={{ borderBottom: "1px solid lightgray" }}
      >
        <span>
          <b>{option.NewBarcode || option.Barcode || ""}</b> - {getArticleName(articleData)} - Çmimi: {option.NewSalesPrice ?? 0}€
        </span>
      </li>
    ),
  };

  useEffect(() => {
    if (!open) {
      return;
    }

    const articleId = getArticleId(articleData);
    const articleBarcode = getArticleBarcode(articleData);

    setBarcode(articleBarcode);
    getFlagCode(articleData);

    if (articleId) {
      fetchArticleSalesOptions(articleId);
    } else {
      setArticleOptions([]);
      setSelectedOption(fallbackOption);
    }
  }, [open, articleData]);

  useEffect(() => {
    if (resolvedArticleOptions.length > 0) {
      setSelectedOption(resolvedArticleOptions[0]);
    } else {
      setSelectedOption(null);
    }
  }, [resolvedArticleOptions]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Barkodi i artikullit:</DialogTitle>
      {/* <DialogContent style={{ padding: "10px" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                    <TextField
                        label="Artikulli"
                        fullWidth
                        value={`${barcode}-${articleData?.ArticleName}`}
                        onChange={(e) => setBarcode(e.target.value)}
                    />
                </div>
                <hr></hr>
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                    <div ref={printRef}>
                        <div style={{ width: "2.29in", height: "1in", border: "solid red 1px", textAlign: "center" }}>
                            <div>
                                <label style={{ fontSize: "12px" }}>{articleData?.ArticleName ? (articleData.ArticleName.length > 30 ? articleData.ArticleName.slice(0, 30) : articleData.ArticleName) : "Emri Artikullit"}</label>
                            </div>
                            <div style={{ display: "flex", height: "0.5in", marginTop: "-5px" }}>
                                <div>
                                    {barcode ? <Barcode value={barcode} width={1} height={15} fontSize={15} /> : <p>Barcode not available</p>}
                                </div>
                                <div>
                                    {countryName && (
                                        <>
                                            <img
                                                src={`/flags/${flagCode}.png`}
                                                alt={`${countryName} Flag`}
                                                width="50"
                                                style={{ paddingTop: "10px" }}
                                            />
                                            <p style={{ fontSize: "12px" }}>{countryName}</p>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div>
                                <p>{articleData?.SalesPrice || "0.00"} €</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <Button onClick={handlePrint} color="primary" variant="contained">
                            Shtyp Tiketën
                        </Button>
                    </div>
                </div>
            </DialogContent> */}
      <DialogContent style={{ padding: "20px", background: "#f8fafc" }}>
        <div style={{ marginBottom: "20px" }}>
          {/* <TextField
            label="Artikulli"
            fullWidth
            value={`${barcode}-${articleData?.ArticleName}`}
            onChange={(e) => setBarcode(e.target.value)}
          /> */}
          <Autocomplete
            {...defaultPropsArticleOptions}
            fullWidth
            id="ArticleOptionsSelect"
            value={selectedOption}
            onChange={(event, newValue) => {
              setSelectedOption(newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Zgjidh Opsionin e Shitjes" />
            )}
          />

          <Autocomplete
            options={LABEL_FORMATS}
            getOptionLabel={(o) => o.label}
            value={selectedFormat}
            onChange={(_, newVal) => { if (newVal) setSelectedFormat(newVal); }}
            disableClearable
            fullWidth
            style={{ marginTop: "12px" }}
            renderInput={(params) => (
              <TextField {...params} label="Formati i printerit" />
            )}
          />
        </div>

        <div
          style={{
            position: "relative",
            marginTop: "20px",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: "-4px",
              background: "linear-gradient(to right,#fee2e2,#fef2f2)",
              borderRadius: "16px",
              filter: "blur(6px)",
              opacity: 0.5,
            }}
          />

          <div
            ref={printRef}
            className="print-label"
            style={{
              position: "relative",
              background: "white",
              border: "1px solid #e2e8f0",
              overflow: "hidden",
              width: selectedFormat.width,
              height: selectedFormat.height,
              padding: "2mm",
              boxSizing: "border-box",
              margin: "auto",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "3px",
                width: "100%",
                background: "#ef4444",
              }}
            />

            <h3
              style={{
                fontSize: `${5.5 * selectedFormat.scale}pt`,
                fontWeight: "500",
                color: "#0f172a",
                textTransform: "uppercase",
                marginBottom: "1mm",
                marginTop: "10px",
                textAlign: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {getArticleName(articleData)
                ? getArticleName(articleData).length > 30
                  ? getArticleName(articleData).slice(0, 30)
                  : getArticleName(articleData)
                : "Emri Artikullit"}
            </h3>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "100%",
                gap: "1mm",
              }}
            >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flexShrink: 0,
                    marginLeft: "25%",
                    marginTop :"10px"
                  }}
                >
                  {barcodeValue ? (
                    <Barcode
                      value={barcodeValue}
                      width={0.9 * selectedFormat.scale}
                      height={25 * selectedFormat.scale}
                      fontSize={Math.round(7 * selectedFormat.scale) + 2}
                      margin={0}
                    />
                  ) : (
                    <p>Barcode not available</p>
                  )}

                {/* <span
                  style={{
                    fontFamily: "monospace",
                    fontSize: "12px",
                    color: "#64748b",
                    letterSpacing: "2px",
                  }}
                >
                  {selectedOption ? selectedOption.NewBarcode : ""}
                </span> */}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: "0.5mm",
                  flexShrink: 0,
                  marginTop: "10px",
                }}
              >
                {countryName && (
                  <>
                    <img
                      src={`/flags/${flagCode}.png`}
                      alt={`${countryName} Flag`}
                      width={Math.round(24 * selectedFormat.scale)}
                      style={{ marginBottom: "0" }}
                    />
                    <span style={{ fontSize: `${8 * selectedFormat.scale}pt`, color: "#64748b", marginBottom: "0.5mm" }}>
                      {countryName}
                    </span>
                  </>
                )}

                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: "1px",
                    marginTop: "0",
                  }}
                >
                  <span
                    style={{
                      fontSize: `${11 * selectedFormat.scale}pt`,
                      fontWeight: "700",
                      color: "#0f172a",
                      lineHeight: 1,
                    }}
                  >
                    {selectedOption ? parseFloat(selectedOption.NewSalesPrice ?? 0).toFixed(2) : (getArticleSalesPrice(articleData) != null ? parseFloat(getArticleSalesPrice(articleData)).toFixed(2) : "0.00")}
                  </span>

                  <span
                    style={{
                      fontSize: `${11 * selectedFormat.scale}pt`,
                      fontWeight: "700",
                      color: "#475569",
                    }}
                  >
                    €
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <button
          style={{
            width: "100%",
            borderRadius: "12px",
            padding: "14px",
            fontWeight: 600,
            cursor: "pointer",
            background: "#2563eb",
            color: "white",
            border: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Printer size={20} />
          SHTYP TIKETËN
        </button> */}
        {/* <button
          onClick={closeModal}
          color="secondary"
          style={{
            width: "100%",
            borderRadius: "12px",
            padding: "14px",
            fontWeight: 600,
            cursor: "pointer",
            background: "transparent",
            color: "#64748b",
            border: "none",
          }}
        >
          MBYLL
        </button> */}
        {/* <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handlePrint}
            variant="contained"
            style={{
              background: "#2563eb",
              padding: "10px 20px",
              borderRadius: "10px",
            }}
          >
            Shtyp Tiketën
          </Button>
        </div> */}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handlePrintClick}
          variant="contained"
          style={{ width: "100%" }}
        >
          <Printer size={20} />
          SHTYP TIKETËN
        </Button>
        <Button
          onClick={closeModal}
          color="secondary"
          style={{ width: "100%" }}
        >
          Mbyll
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BarcodeGeneratorModal;
